import { createEntitySchemas } from '../../../utils/normalize'

export const NEEDS = 'needs'
export const needsSchemas = createEntitySchemas(NEEDS)
